import { getPopularList } from "@/app/product/_actions/popularcar.actions";

// Shared in-flight/completed-request cache, keyed by the exact (cityId,
// productType, salary) triple. Several independent homepage components
// (useBottomNavData - itself called from 3 places - plus category-section's
// and accessories-banner-section's own fallback fetches) all ask for the
// same "popular products for this city/type" data around the same moment;
// without this, each one fires its own request. A genuinely different
// salary value can legitimately change which products come back, so the key
// uses the literal value passed rather than a normalized/defaulted one -
// callers passing the same value share a result, callers passing a
// different value correctly get their own. Mirrors the same pattern used
// for useConfig.
const popularListCache = new Map<string, ReturnType<typeof getPopularList>>();

export const fetchPopularList = async ({
	cityId,
	productType,
	salary,
}: {
	cityId: string;
	salary: number;
	productType: ProductType;
}) => {
	const cacheKey = `${cityId}:${productType}:${salary}`;
	if (!popularListCache.has(cacheKey)) {
		const request = getPopularList({ cityId, productType, salary }).catch(
			(error) => {
				// Don't leave a failed request permanently cached - let the next
				// caller retry instead of getting stuck on one transient failure.
				popularListCache.delete(cacheKey);
				throw error;
			},
		);
		popularListCache.set(cacheKey, request);
	}
	return popularListCache.get(cacheKey);
};
